import api from '@/services/api'

const BASE_URL = '/keyresults'
const BASE_INITIATIVE_URL = '/initiatives'
const today = new Date().toISOString().slice(0, 10)

const getKeyResult = async (krId) => {
    try {
        const response = await api.get(`${BASE_URL}/${krId}`, {
            params: {
                with: 'user;objective;objective.period',
                and: 'yes',
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const getActiveKeyResults = async (userId, managerId) => {
    try {
        const response = await api.get(`${BASE_URL}`, {
            params: {
                search: `user_id:${userId},${managerId};status:done;objective.period.end_date:${today}`,
                searchFields: 'user_id:in;status:!=;objective.period.end_date:>=',
                with: 'user;objective;objective.period',
                and: 'yes',
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const searchByKeyResultName = async (search) => {
    try {
        const response = await api.get(`${BASE_URL}`, {
            params: {
                search: `title:${search};status:done;objective.period.end_date:${today}`,
                searchFields: 'title:like;status:!=;objective.period.end_date:>=',
                with: 'user;objective;objective.period',
                and: 'yes',
            },
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

const linkKeyResultToInitiative = async (keyResultId, initiative) => {
    try {
        const response = await api.put(`${BASE_INITIATIVE_URL}/${initiative.id}`, {
            title: initiative.title,
            key_result_id: keyResultId,
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export { getKeyResult, getActiveKeyResults, searchByKeyResultName, linkKeyResultToInitiative }
